import React, { useState } from "react";
import SideBar from "../SideBar/SideBar";
import authStore from "../../store/authStore";

export default function MainLayout({ children }) {
  const [isShowSideBar, setShowSideBar] = useState(true);
  const showDeleteBox = authStore((state) => state.showDeleteBox);
  const auth = authStore((state) => state.auth);
  const showSideBar = (value) => {
    setShowSideBar(value);
  };

  if (auth) {
    return (
      <>
        <SideBar
          isShowSideBar={isShowSideBar}
          setShowSideBar={showSideBar}
        />
        <main
          className={
            isShowSideBar ? "pageContainer" : "hideSideBarTextContainer"
          }
        >
          {children}
        </main>
        <div className={showDeleteBox ? "showDeleteBox" : ""}></div>
      </>
    );
  }

  window.location.href = "/login";
}
